import { render, staticRenderFns } from "./ContactsList.vue?vue&type=template&id=1f7c3e08&scoped=true&"
import script from "./ContactsList.vue?vue&type=script&lang=js&"
export * from "./ContactsList.vue?vue&type=script&lang=js&"
import style0 from "./ContactsList.vue?vue&type=style&index=0&id=1f7c3e08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7c3e08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
